import moment from 'moment';
import { RangeState } from '@philips-internal/oswald-ui-constants';
import { array, arrayOf, bool, date, eventListener, number, oneOf, oneOfType, shape, string } from '@philips-internal/oswald-ui-core/prop-types';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { DatePickerMode } from './date-picker-constants.js';
const DatePickerProperties = {
    data: {
        defaultValue: [],
        type: array,
    },
    enabled: {
        defaultValue: true,
        type: bool.notEnumerable(),
    },
    externalControls: {
        type: bool.notEnumerable(),
    },
    initialDate: {
        defaultValue: moment.utc().toISOString(),
        type: oneOfType([date, string]),
    },
    interval: {
        defaultValue: false,
        type: bool,
    },
    intervalThreshold: {
        defaultValue: 0,
        type: number,
    },
    isModalWrapped: {
        defaultValue: false,
        type: bool,
    },
    loading: {
        defaultValue: false,
        type: bool,
    },
    mode: {
        defaultValue: DatePickerMode.MONTHLY,
        type: oneOf(enumValues(DatePickerMode)),
    },
    nativeOnMobile: {
        defaultValue: false,
        type: bool,
    },
    onAfterNavigate: {
        type: eventListener,
    },
    onChange: {
        type: eventListener,
    },
    onCollapse: {
        type: eventListener,
    },
    onNavigate: {
        type: eventListener,
    },
    ranges: {
        defaultValue: [],
        type: arrayOf(shape({ endDate: string, startDate: string })).notEnumerable(),
    },
    rangeState: {
        defaultValue: RangeState.DISABLED,
        type: oneOf(enumValues(RangeState)),
    },
    showApply: {
        defaultValue: true,
        type: bool,
    },
    showClear: {
        defaultValue: true,
        type: bool,
    },
    showEvents: {
        defaultValue: false,
        type: bool,
    },
    showExpander: {
        defaultValue: false,
        type: bool,
    },
    showNavigationArrows: {
        defaultValue: true,
        type: bool,
    },
    value: {
        type: oneOfType([string, arrayOf(string)]),
    },
    weekMonthly: {
        defaultValue: false,
        type: bool,
    },
};
export { DatePickerProperties, };
//# sourceMappingURL=date-picker-types.js.map